import React from "react";
import {Link} from "react-router-dom";
function SectionLink(props) {
  return (
    <span className="navigation-section-link purple-text bold my-3" {...props}>
      <Link to={props.link}>{props.title}</Link>
    </span>
  );
}

export default SectionLink;
